import DistributeElements from './DistributeElements';

export default {
  __init__: [ 'distributeElements' ],
  distributeElements: [ 'type', DistributeElements ]
};
